import { type Locale, defaultLocale } from "../i18n/config";
import {
  getCookieValue,
  localeCookieNames,
  resolveLocale,
  serializeLocaleCookie,
} from "./locale";

/**
 * Client-side locale utilities
 * Replaces server-side getAppLocale and setAppLocale
 */

export function getAppLocale(): Locale {
  if (typeof document === "undefined") {
    return defaultLocale;
  }

  return resolveLocale({
    cookieValues: localeCookieNames.map((name) =>
      getCookieValue(document.cookie, name)
    ),
    browserLocale: navigator.language,
    fallback: defaultLocale,
  });
}

export function setAppLocale(locale: Locale): void {
  if (typeof document === "undefined") {
    return;
  }

  localeCookieNames.forEach((name) => {
    document.cookie = serializeLocaleCookie(name, locale);
  });
}
